module.exports = __webpack_public_path__ + "static/img/icon_kaipiaoshenqing@3x4afb46a.png";